import { render } from "./process_report.vue?vue&type=template&id=8a21fb52"
import script from "./process_report.vue?vue&type=script&lang=js"
export * from "./process_report.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__